<template>
  <el-dialog :title="title" :width="width" draggable class="account-modal">
    <slot name="bodyForm" />
    <template #footer>
      <slot name="footerForm" />
      <span class="dialog-footer">
        <argon-button
          type="reset"
          color="secondary"
          size="xs"
          variant="gradient"
          class="el-button"
          @click="$emit('on-cancel')"
          >Cancel</argon-button
        >
        <argon-button
          type="submit"
          color="success"
          size="xs"
          variant="gradient"
          class="el-button"
          >Confirm</argon-button
        >
      </span>
    </template>
  </el-dialog>
</template>

<script>
import { defineComponent } from "vue";
import ArgonButton from "@/components/ArgonButton.vue";

export default defineComponent({
  name: "ModalForm",
  components: {
    ArgonButton,
  },
  props: {
    title: {
      type: String,
      default: "Default Title",
    },
    width: {
      type: String,
      default: "50%",
    },
  },

  setup() {
    return {};
  },
});
</script>

<style>
.account-modal {
  border-radius: 0.75rem;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.18);
}

.account-modal .el-dialog__header {
  background: #0f172a;
  margin-right: 0;
  padding: 1rem 1.5rem;
}

.account-modal .el-dialog__title {
  color: #fff;
  font-weight: 700;
}

.account-modal .el-dialog__headerbtn .el-dialog__close {
  color: #cbd5e1;
}
</style>
